import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { SalService } from 'src/app/Services/sal/sal.service';
import { ConfirmationDialogService } from 'src/app/services/sal/confirmation-dialog.service';
import { WindowRefService } from 'src/app/services/Common/window-ref.service';


@Component({
  selector: 'app-pay',
  templateUrl: './pay.component.html',
  styleUrls: ['./pay.component.css']
})
export class PayComponent implements OnInit {
  ReceiptNo:any='';
  PaymentModel={
    PGOrderNo:"",
    OrderNo:"",
    PaidAmount:0,
    CreditAmount:0,
    CurrencyCode:"",
    Key:"",
    Email:"",
    Mobile:'',
    CustomerName:"",
    CustomerID:0,
    RefernceNo:"",
    Signature:"",
    ReceiptNo:"",
    CurrencyRate:"",
    
  };
  constructor(private confirmationDialogService: ConfirmationDialogService,private router: Router,private Productservice: SalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService,private winRef: WindowRefService) {  
    
  }

  responseData:any;
  CreateRazorOrder(){
    this.PaymentModel.PaidAmount=this.SaleOrderList.OrderAmount;
    this.PaymentModel.PGOrderNo=this.SaleOrderList.PGOrderNo;
    this.PaymentModel.OrderNo=this.SaleOrderList.OrderNo;   
    this.PaymentModel.CurrencyCode=this.SaleOrderList.CurrencyCode;  
    this.PaymentModel.CurrencyRate=this.SaleOrderList.CurrencyRate;  
    this.PaymentModel.CustomerName=this.SaleOrderList.GroupName;  
    this.PaymentModel.Mobile=this.SaleOrderList.MobileNo;  
    this.PaymentModel.Email=this.SaleOrderList.Email;  
    if(this.PaymentModel.PaidAmount>0){
    this.Productservice.CreateRazorOrder(JSON.stringify(this.PaymentModel)).subscribe((data) => {
       this.responseData = data;
            if(this.responseData.status){
              this.PaymentModel.Key=this.responseData.Key;
              this.PaymentModel.PGOrderNo=this.responseData.PGOrderNo;
           this.payWithRazor();
        
              }
      else{
      alert("Your request is not processed successfully. Please try again after clicking Pay button.");
      }
       

    });
  }
  else{
this.VerifyRazorOrderPayment(this.PaymentModel);

  }
  }
   payWithRazor() {
   
    const options: any = {
    key: this.PaymentModel.Key,
    amount: this.PaymentModel.PaidAmount*100, // amount should be in paise format to display Rs 1255 without decimal point
    currency: this.PaymentModel.CurrencyCode,
    name: 'JDAAS', // company name or product name
    description: 'HOSTING SERVICES',  // product description
    image: 'assets/logo/jdaaslogo.png', // company logo or product image
    order_id: this.PaymentModel.PGOrderNo, // order_id created by you in backend      
    merchant_order_id:this.PaymentModel.OrderNo,
    prefill: {
      email: this.PaymentModel.Email,
      contact:this.PaymentModel.Mobile,
      name: this.PaymentModel.CustomerName
     
    },
    modal: {
      // We should prevent closing of the form when esc key is pressed.
      escape: false,
    },
    notes: {
      // include notes if any
    },
    theme: {
      color: '#0c238a'
    }
  };
  options.handler = ((response, error) => {
    options.response = response;
         this.PaymentModel.RefernceNo=options.response .razorpay_payment_id;  
        this.PaymentModel.Signature=options.response .razorpay_signature;            
         
        this.VerifyRazorOrderPayment(options.response )

  
      // this.router.navigate(['/success'])
  });
  options.modal.ondismiss = (() => {
    // handle the case when user closes the form while transaction is in progress
    console.log('Transaction cancelled.');
  });
  const rzp = new this.winRef.nativeWindow.Razorpay(options);
  rzp.open();

 
}

VerifyRazorOrderPayment(item){
 
this.Productservice.VerifyRazorOrderPayment(JSON.stringify(this.PaymentModel)).subscribe((data) => {
  this.responseData = data;
  
       if(this.responseData.webResponse.Status){
         this.PaymentModel.ReceiptNo=this.responseData.ReceiptNo;           
         this.globalHelper.CheckActionStatus(data);
         if(this.PaymentModel.PaidAmount>0){
         window.localStorage.setItem("razorpay_payment_id", item.razorpay_payment_id);
         window.localStorage.setItem("razorpay_signature", item .razorpay_signature);
         window.localStorage.setItem("razorpay_order_id", item.razorpay_order_id);
       }
         window.localStorage.setItem("ReceiptNo", this.PaymentModel.ReceiptNo);
         window.location.reload();

 }
 else{
 alert("Your request is not processed successfully. Please try again after clicking Pay button.");
 }
  

});

}




SaleModel = {         
  OrderNo: "",     
  SaleOrderID:0,     
  CustomerID:this.globalHelper.GetLoginToken().SchoolID,
 
};
SaleOrderList:any;
SumTotalTax:any;
TotalAmount:any;
GetSaleOrderByOrderNo() {
  this.spinnerService.show();
    this.Productservice.GetSaleOrderByOrderNo(JSON.stringify(this.SaleModel)).subscribe((response: any) => {
        this.SaleOrderList = response.SaleOrderList[0];
        
        this.SumTotalTax=0;
        this.TotalAmount=0;
        for (let index = 0; index < this.SaleOrderList.ItemList.length; index++) {
          
          this.SumTotalTax=this.SumTotalTax+this.SaleOrderList.ItemList[index].TaxAmount;
          this.TotalAmount=this.TotalAmount+this.SaleOrderList.ItemList[index].Amount*this.SaleOrderList.ItemList[index].Qty;
        }
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
        
    });
};





GetReceipt()
{
 return window.localStorage.getItem("ReceiptNo")==null?'': window.localStorage.getItem("ReceiptNo");
}

  ngOnInit() {
   
   this.SaleModel.OrderNo=window.history.state.OrderNo; 
  if(this.SaleModel.OrderNo!=undefined){
    this.GetSaleOrderByOrderNo();
    
  }
  else if(this.GetReceipt()!='')
  {

    this.router.navigate(['/success'])
  }
  else{
    
    this.router.navigate(['/dashboard'])
    
  }
   
  }

}

